import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { Shield, Eye, EyeOff } from 'lucide-react'
import { authAPI } from '../api/auth'
import { useAuthStore } from '../store/authStore'
import type { User } from '../store/authStore'

// type Step = 'phone' | 'register' | 'otp'
// type LoginMode = 'phone' | 'email'
type LoginMode = 'email'
// type Role = 'admin' | 'expediteur' | 'livreur'

// const ROLE_LABELS: Record<Role, string> = {
//   admin: 'Administrateur',
//   expediteur: 'Expéditeur',
//   livreur: 'Livreur',
// }

export default function Login() {
  // const [params] = useSearchParams()
  const navigate = useNavigate()
  const setUser = useAuthStore((s) => s.setUser)

  // const urlRole = params.get('role') as Role | null
  const loginMode: LoginMode = 'email'
  // const [step, setStep] = useState<Step>('phone')
  // const [role, setRole] = useState<Role>(urlRole ?? 'expediteur')
  // const [phone, setPhone] = useState('')
  // const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  // const [otp, setOtp] = useState(['', '', '', '', '', ''])
  // const [countdown, setCountdown] = useState(60)
  const [loading, setLoading] = useState(false)
  // const otpRefs = useRef<(HTMLInputElement | null)[]>([])
  // const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // useEffect(() => {
  //   if (step !== 'otp') return
  //   setCountdown(60)
  //   timerRef.current = setInterval(() => {
  //     setCountdown((c) => {
  //       if (c <= 1) { clearInterval(timerRef.current!); return 0 }
  //       return c - 1
  //     })
  //   }, 1000)
  //   return () => clearInterval(timerRef.current!)
  // }, [step])

  // async function handleSendPhone() {
  //   const full = `+216${phone}`
  //   setLoading(true)
  //   try {
  //     await authAPI.login(full)
  //     setStep('otp')
  //   } catch (err: unknown) {
  //     const e = err as { response?: { status?: number } }
  //     if (e?.response?.status === 404) {
  //       setStep('register')
  //     } else {
  //       toast.error("Erreur lors de l'envoi du code")
  //     }
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  // async function handleRegister() {
  //   const full = `+216${phone}`
  //   setLoading(true)
  //   try {
  //     await authAPI.register(full, name, role)
  //     setStep('otp')
  //   } catch {
  //     toast.error("Erreur lors de l'inscription")
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  // async function handleVerifyOTP() {
  //   const code = otp.join('')
  //   if (code.length < 6) return
  //   const full = `+216${phone}`
  //   setLoading(true)
  //   try {
  //     const res = await authAPI.verifyOTP(full, code)
  //     setUser(res.data.user as User, res.data.accessToken)
  //     navigate('/dashboard', { replace: true })
  //   } catch {
  //     toast.error('Code OTP incorrect')
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  async function handleEmailLogin() {
    setLoading(true)
    try {
      const res = await authAPI.loginEmail(email, password)
      setUser(res.data.user as User, res.data.accessToken)
      navigate('/dashboard', { replace: true })
    } catch (err: unknown) {
      const e = err as { response?: { status?: number } }
      if (e?.response?.status === 401) {
        toast.error('Email ou mot de passe incorrect')
      } else if (e?.response?.status === 403) {
        toast.error('Compte désactivé')
      } else {
        toast.error('Erreur de connexion')
      }
    } finally {
      setLoading(false)
    }
  }

  // async function handleResend() {
  //   const full = `+216${phone}`
  //   try {
  //     await authAPI.login(full)
  //     setStep('otp')
  //     toast.success('Code renvoyé')
  //   } catch {
  //     toast.error('Erreur lors du renvoi')
  //   }
  // }

  // function handleOtpChange(val: string, idx: number) {
  //   if (!/^\d?$/.test(val)) return
  //   const next = [...otp]
  //   next[idx] = val
  //   setOtp(next)
  //   if (val && idx < 5) otpRefs.current[idx + 1]?.focus()
  // }

  // function handleOtpKeyDown(e: React.KeyboardEvent, idx: number) {
  //   if (e.key === 'Backspace' && !otp[idx] && idx > 0) otpRefs.current[idx - 1]?.focus()
  // }

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '12px 14px', borderRadius: '10px',
    border: '1px solid #e5e7eb', fontSize: '15px', outline: 'none',
    background: '#fafafa', transition: 'border-color 0.15s',
  }

  const btnStyle: React.CSSProperties = {
    width: '100%', padding: '13px', borderRadius: '10px', border: 'none',
    background: loading ? '#9ca3af' : '#1D9E75', color: '#fff', fontSize: '15px',
    fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer',
    transition: 'background 0.2s',
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '20px', padding: '40px',
        width: '100%', maxWidth: '420px', display: 'flex', flexDirection: 'column', gap: '24px',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
          <Shield size={22} color="#1D9E75" />
          <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: '20px', color: '#1D9E75' }}>
            TariqGo
          </span>
        </div>

        {/* Mode toggle — visible uniquement sur l'étape initiale */}
        {/* {(step === 'phone' || loginMode === 'email') && step !== 'otp' && step !== 'register' && (
          <div style={{ display: 'flex', gap: '4px', background: '#f3f4f6', borderRadius: '10px', padding: '4px' }}>
            {(['phone', 'email'] as LoginMode[]).map((m) => (
              <button
                key={m}
                onClick={() => { setLoginMode(m); setStep('phone') }}
                style={{
                  flex: 1, padding: '8px', borderRadius: '8px', border: 'none',
                  background: loginMode === m ? '#fff' : 'transparent',
                  color: loginMode === m ? '#1D9E75' : '#6b7280',
                  fontSize: '13px', fontWeight: loginMode === m ? 600 : 400,
                  cursor: 'pointer', boxShadow: loginMode === m ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.15s',
                }}
              >
                {m === 'phone' ? 'Téléphone' : 'Email'}
              </button>
            ))}
          </div>
        )} */}

        {/* Connexion par email */}
        {loginMode === 'email' && (
          <>
            <div>
              <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '22px', marginBottom: '6px' }}>
                Connexion
              </h2>
              <p style={{ color: '#6b7280', fontSize: '14px' }}>Connectez-vous avec votre email</p>
            </div>
            <input
              style={inputStyle}
              type="email"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleEmailLogin() }}
              onFocus={(e) => { e.target.style.borderColor = '#1D9E75' }}
              onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
            />
            <div style={{ position: 'relative' }}>
              <input
                style={{ ...inputStyle, paddingRight: '44px' }}
                type={showPassword ? 'text' : 'password'}
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleEmailLogin() }}
                onFocus={(e) => { e.target.style.borderColor = '#1D9E75' }}
                onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                style={{
                  position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                  color: '#9ca3af', display: 'flex', alignItems: 'center',
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <button
              style={btnStyle}
              onClick={handleEmailLogin}
              disabled={loading || !email.trim() || !password.trim()}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </>
        )}

        {/* Étape téléphone */}
        {/* 
        {loginMode === 'phone' && step === 'phone' && (
          <>
            <div>
              <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '22px', marginBottom: '6px' }}>
                Connexion
              </h2>
              <p style={{ color: '#6b7280', fontSize: '14px' }}>Entrez votre numéro pour recevoir un code</p>
            </div>

            {!urlRole && (
              <div style={{ display: 'flex', gap: '8px' }}>
                {(['admin', 'expediteur', 'livreur'] as Role[]).map((r) => (
                  <button
                    key={r}
                    onClick={() => setRole(r)}
                    style={{
                      flex: 1, padding: '8px 4px', borderRadius: '8px', border: '2px solid',
                      borderColor: role === r ? '#1D9E75' : '#e5e7eb',
                      background: role === r ? '#E1F5EE' : '#fff',
                      color: role === r ? '#1D9E75' : '#374151',
                      fontSize: '12px', fontWeight: 500, cursor: 'pointer',
                      transition: 'all 0.15s',
                    }}
                  >
                    {ROLE_LABELS[r]}
                  </button>
                ))}
              </div>
            )}

            {urlRole && (
              <div style={{
                padding: '10px 14px', background: '#E1F5EE', borderRadius: '8px',
                color: '#1D9E75', fontSize: '14px', fontWeight: 500,
              }}>
                Connexion en tant que {ROLE_LABELS[urlRole]}
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{
                padding: '12px 14px', borderRadius: '10px', border: '1px solid #e5e7eb',
                background: '#f3f4f6', fontSize: '15px', whiteSpace: 'nowrap',
              }}>
                +216
              </div>
              <input
                style={{ ...inputStyle, flex: 1 }}
                type="tel"
                placeholder="XX XXX XXX"
                maxLength={8}
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSendPhone() }}
                onFocus={(e) => { e.target.style.borderColor = '#1D9E75' }}
                onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
              />
            </div>
            <button style={btnStyle} onClick={handleSendPhone} disabled={loading || phone.length < 8}>
              {loading ? 'Envoi...' : 'Recevoir le code'}
            </button>
          </>
        )}*/}

        {/* Étape inscription */}
        {/* {loginMode === 'phone' && step === 'register' && (
          <>
            <div>
              <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '22px', marginBottom: '6px' }}>
                Créer un compte
              </h2>
              <p style={{ color: '#6b7280', fontSize: '14px' }}>Numéro non trouvé — complétez votre profil</p>
            </div>
            <input
              style={inputStyle}
              placeholder="Votre nom complet"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocus={(e) => { e.target.style.borderColor = '#1D9E75' }}
              onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
            />
            <div style={{ display: 'flex', gap: '8px' }}>
              {(['admin', 'expediteur', 'livreur'] as Role[]).map((r) => (
                <button
                  key={r}
                  onClick={() => setRole(r)}
                  style={{
                    flex: 1, padding: '8px 4px', borderRadius: '8px', border: '2px solid',
                    borderColor: role === r ? '#1D9E75' : '#e5e7eb',
                    background: role === r ? '#E1F5EE' : '#fff',
                    color: role === r ? '#1D9E75' : '#374151',
                    fontSize: '12px', fontWeight: 500, cursor: 'pointer',
                    transition: 'all 0.15s',
                  }}
                >
                  {ROLE_LABELS[r]}
                </button>
              ))}
            </div>
            <button style={btnStyle} onClick={handleRegister} disabled={loading || !name.trim()}>
              {loading ? 'Inscription...' : 'S\'inscrire et recevoir le code'}
            </button>
            <button
              onClick={() => setStep('phone')}
              style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '14px' }}
            >
              ← Retour
            </button>
          </>
        )} */}

        {/* Étape OTP */}
        {/* {loginMode === 'phone' && step === 'otp' && (
          <>
            <div>
              <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '22px', marginBottom: '6px' }}>
                Code de vérification
              </h2>
              <p style={{ color: '#6b7280', fontSize: '14px' }}>
                Code envoyé au <strong>+216{phone}</strong>
              </p>
            </div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
              {otp.map((digit, i) => (
                <input
                  key={i}
                  ref={(el) => { otpRefs.current[i] = el }}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  onKeyDown={(e) => handleOtpKeyDown(e, i)}
                  style={{
                    width: '48px', height: '56px', textAlign: 'center', fontSize: '22px',
                    fontWeight: 600, borderRadius: '10px', border: '2px solid',
                    borderColor: digit ? '#1D9E75' : '#e5e7eb',
                    outline: 'none', background: '#fafafa',
                    transition: 'border-color 0.15s',
                  }}
                  onFocus={(e) => { e.target.style.borderColor = '#1D9E75' }}
                  onBlur={(e) => { e.target.style.borderColor = otp[i] ? '#1D9E75' : '#e5e7eb' }}
                />
              ))}
            </div>
            <div style={{ textAlign: 'center', fontSize: '13px', color: '#9ca3af' }}>
              {countdown > 0 ? (
                `Renvoyer dans ${countdown}s`
              ) : (
                <button
                  onClick={handleResend}
                  style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}
                >
                  Renvoyer le code
                </button>
              )}
            </div>
            <button
              style={btnStyle}
              onClick={handleVerifyOTP}
              disabled={loading || otp.join('').length < 6}
            >
              {loading ? 'Vérification...' : 'Confirmer'}
            </button>
            <button
              onClick={() => setStep('phone')}
              style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '14px' }}
            >
              ← Modifier le numéro
            </button>
          </>
        )} */}
      </div>
    </div>
  )
}
